import StatusButtonRoot, { Props } from './StatusButton'

export default function StatusButton(props: Props) {
  return <StatusButtonRoot {...props} />
}

export type { Props }
